import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import MedicalSoftwareQuotesWrapper from "@components/layouts/medicalsoftwareWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function MedicalSoftwareQuotesHome(): ReactElement {
    return (
        <MedicalSoftwareQuotesWrapper>
            <TermsAndConditions
                domain="MedicalSoftwareQuotes.com"
                category="Medical Software"
            />
        </MedicalSoftwareQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
